import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import type { RootState } from '@/state/store';
import TestOptimizationPanel from './TestOptimizationPanel';
import {
  testOptEmptyCardClass,
  testOptPageClass,
} from './test-optimization-layout';

const TestOptimizationPage = () => {
  const component = useSelector(
    (state: RootState) => state.userSelectedComponentSlice,
  );
  const navigate = useNavigate();
  const scanId = component.scanId?.trim() || '';

  if (!scanId) {
    return (
      <div className={testOptPageClass}>
        <div className={testOptEmptyCardClass}>
          <p className="m-0 mb-4 text-sm leading-6 text-[var(--inv-text-secondary)]">
            No scan is selected. Choose a component from the list, tehn open Test
            optimization from Build Diff.
          </p>
          <Button
           variant="secondary"
           onClick={() =>
            navigate(
              `/sia/components/code_analysis/build_analysis/${component.dbRepoId}`,
            )
          }>
            Back to Build Diff
          </Button>
        </div>
      </div>
    );
  }

  return (
    <TestOptimizationPanel
      scanId={scanId}
      codeRepositoryMongoId={component.dbRepoId}
      repoUrl={component.repoUrl}
      branchName={component.branchName}
      patToken={component.pat}
    />
  );
};

export default TestOptimizationPage;
